// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./footer/styles.scss
// module id = 935
// module chunks = 0